import { render, staticRenderFns } from "./favorites.vue?vue&type=template&id=be407db2&scoped=true"
import script from "./favorites.vue?vue&type=script&lang=js"
export * from "./favorites.vue?vue&type=script&lang=js"
import style0 from "./favorites.vue?vue&type=style&index=0&id=be407db2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be407db2",
  null
  
)

export default component.exports